import { getPageReferrer } from '../../../../../scripts/utilities/helpers';

export default (
  pnrInfo,
  user,
  subFunnelName,
  storeFront,
  corporate = undefined,
) => {
  const translations = {
    'Clasico': 'Classic',
    'Oro': 'Gold',
    'Plata': 'Silver',
    'Platino': 'Platinum',
    'Titanio': 'Titanium',
  };
  const userId = user?.ffNumber || 'Guest';
  const amrPoints = user?.account?.balance || '0';
  const amrCobrandCollection = user?.account?.cobrandCardCollection?._collection;
  const pageLocation = document?.location?.pathname || 'NA';
  const collections = user?.personalCreditCards?._collection;
  const corpSpid = pnrInfo?.clid?.companyNumber || 'NA';
  const pageReferrer = getPageReferrer(document?.referrer);
  const screenWidth = window?.innerWidth;
  const screenHeight = window?.innerHeight;
  let corpDiscount = 'NA';
  const pageTittle = document?.title || 'NA';
  const language = navigator?.language || 'NA';

  let amrCobrand = '';

  if (amrCobrandCollection) {
    amrCobrandCollection.forEach(amrCobrandItem => {
      const code = amrCobrandItem?.code?.trim();
      amrCobrand += code + '|';
    });
  }

  amrCobrand = amrCobrand.endsWith('|') ? amrCobrand.slice(0, -1) : amrCobrand;
  amrCobrand = amrCobrand ? amrCobrand : 'NA';

  let visaCount = 0;
  let amexCount = 0;
  let mastercardCount = 0;
  let amrTier = 'NA';
  let profileType = 'NA';
  const isCorporate = corporate ? Boolean(corporate.isSwitchCorporate) : user?.corporateFlow?.data?.companies;

  if (user?.ffNumber) {
    amrTier = translations[user?.account?.tier] || 'Caballero Águila';
    profileType = isCorporate ? 'Corporate' : 'Regular';
  }

  if (isCorporate) {
    corpDiscount = pnrInfo?.corporateFlow?.accountCode;
  }

  if (collections) {
    collections.forEach(collection => {
      const cardType = collection?.cardType?.toUpperCase();
      switch (cardType) {
        case 'VISA':
          visaCount++;
          break;
        case 'AMEX':
          amexCount++;
          break;
        case 'MASTER':
          mastercardCount++;
          break;
        default:
          break;
      }
    });
  }

  let pmtCards = '';
  if (collections) {
    collections.forEach(collection => {
      const isCobranCard = collection?.isCobranCard;
      if (isCobranCard) {
        const codeCard = collection?.codeCobranCard;
        pmtCards += codeCard + '|';
      }
    });
  }
  pmtCards = pmtCards.endsWith('|') ? pmtCards.slice(0, -1) : pmtCards;
  pmtCards = pmtCards ? pmtCards : 'NA';

  return {
    event: 'user_properties',
    'funnel_name': 'MYB',
    'sub_funnel_name': subFunnelName,
    'user_id': userId,
    'points_amr': amrPoints,
    'storefront': storeFront,
    'amr_tier': amrTier,
    'amr_cobrand': amrCobrand,
    'profile_type': profileType,
    'ax_cards': amexCount,
    'mc_cards': mastercardCount,
    'vs_cards': visaCount,
    'pmt_cards': pmtCards,
    'corp_spid': corpSpid,
    'corp_discount': corpDiscount,
    'page_location': pageLocation,
    'page_title': pageTittle,
    'page_referrer': pageReferrer,
    'screen_resolution': `${screenWidth}x${screenHeight}`,
    'language': language,
  };
};
